export default "__VITE_ASSET__Vo2oLgSQ__"